import { GlobalStyles } from '@styles/global'
import { theme } from '@styles/theme'
import { transitions } from '@styles/transitions'

export { GlobalStyles, theme, transitions }
